

export function formatTokenAmount(value: number): string {
  if (!value || value === 0) return '0';
  if (value >= 1) return value.toFixed(4).replace(/\.?0+$/, '');
  if (value >= 0.01) return value.toFixed(5).replace(/\.?0+$/, '');
  if (value >= 0.000001) return value.toFixed(7).replace(/\.?0+$/, '');
  return value.toExponential(2); // ex: 1.23e-6
}

export function formatFiatAmount(value: number, currency: string = 'USD'): string {
  if (!value || isNaN(value)) return `0 ${currency}`;
  return `${value.toFixed(2)} ${currency}`;
}
